const DEFAULT_HIVE_RPC_NODES = [
  'https://api.hive.blog',
  'https://api.deathwing.me',
  'https://hive.atexoras.com:2096/',
  'https://hived.emre.sh',
  'https://rpc.ausbit.dev',
  'https://api.openhive.network'
];

const parseNodes = (value) =>
  String(value || '')
    .split(',')
    .map(node => node.trim())
    .filter(Boolean);

const envNodes = parseNodes(process.env.REACT_APP_HIVE_RPC_NODES);

export const HIVE_RPC_NODES = envNodes.length > 0 ? envNodes : DEFAULT_HIVE_RPC_NODES;

export default HIVE_RPC_NODES;
